import castArray from "lodash/fp/castArray";
import flow from "lodash/fp/flow";
import map from "lodash/fp/map";

import getSvgComponents from "./getSvgComponents";

export default function getAllSvgComponents({ signal, allImages }) {
  const requests = flow(
    castArray,
    map(async ({ imageSet, images = [] }) => {
      const svgImages = images.filter((img) => img?.type === "svg");
      const otherImages = images.filter((img) => img?.type !== "svg");

      const svgPaths = await Promise.all(
        svgImages.map(({ url, fill }) => {
          return getSvgComponents({ signal })({ url, fill });
        })
      );
      return { imageSet, svgsPathsAndImages: [...svgPaths, ...otherImages] };
    })
  )(allImages);

  return Promise.all(requests);
}
